import React from 'react';
import styled from 'styled-components';
import Grid from '@/components/molecules/Grid';
import RatingWithModal from '@/components/features/result/RatingWithModal/RatingWithModal';
import { useSelector } from 'react-redux';
import { checkIsOwnAttempt } from '@/store/selectors/ratingSelectors';
import { selectBlocks, selectIsApp } from '@/store/selectors/resultSelectors';
import SocialNetworks from '@/components/features/SocialNetworks/SocialNetworks';
import ConditionalBlock from '@/components/features/result/ConditionalBlock/ConditionalBlock';
import EmbedTest from '@/components/features/widgets/EmbedTest';
import NetworksBlock from '@/components/features/SocialNetworks/NetworksBlock';
import Apps from '@/components/features/SocialNetworks/Apps';

interface ResultSidebarProps {}

export const Wrapper = styled.aside`
  position: sticky;
  top: 10rem;
  height: fit-content;
`;

const ResultSidebar: React.FC<ResultSidebarProps> = () => {
	const isOwnAttempt = useSelector(checkIsOwnAttempt);
	const blocks = useSelector(selectBlocks);
	const socialLinks = blocks.socialLinks;
	const appLinks = blocks.appLinks;
	const ratingBlock = blocks.resultRating;

	return (
		<Wrapper>
			<Grid col='1' gap='5' centeredContent>
				<ConditionalBlock block={ratingBlock}>
					{isOwnAttempt && <RatingWithModal/>}
				</ConditionalBlock>

				{/*<EmbedTest />*/}

				<SocialNetworks >
					<ConditionalBlock block={socialLinks}>
						<NetworksBlock />
					</ConditionalBlock>
					{<ConditionalBlock block={appLinks}>
	                   <Apps />
	                </ConditionalBlock>}
				</SocialNetworks>
			</Grid>
		</Wrapper>
	);
};

export default ResultSidebar;
